<app-status *ngIf="isRuntime"></app-status>
<app-changes-page *ngIf="isRuntime"></app-changes-page>
<app-developer-mode-strip></app-developer-mode-strip>
<div *ngIf="loading.isLoading" class="loading-container fixed h-screen w-screen z-[90] flex items-center justify-center bg-white/80 backdrop-blur-sm transition-all duration-300">
  <!-- DELIBERATELY UNBRANDED. This used to spin the house monogram (the same paths the left-nav and
       login draw, where it is the Zavo logo). The problem is not the mark, it is the surface: this
       ONE component serves both the editor and every published customer app, so whatever sits here
       is shown to a customer's own end users while their app loads. No logo of ours is correct in
       that position, so a plain spinner is the only thing that is right in both. -->
  <div class="flex flex-col items-center justify-center p-8 rounded-lg">
    <div class="loading-spinner" role="status" aria-label="Loading"></div>
    <p class="mt-5 text-sm font-medium text-[#332D2C]">Loading</p>
  </div>
</div>
<!-- Above the loading overlay's z-90: a gated visitor should never see the app flash behind a spinner. -->
<app-mobile-access-gate></app-mobile-access-gate>
<!-- Nav 7b (spec Q1) — one studio bar on every editor screen with no chat of its own. -->
<app-studio-bar *ngIf="!isRuntime"></app-studio-bar>
<div class="w-full set h-full text-[#332D2C]">
  <router-outlet></router-outlet>
</div>
<app-credential-reveal></app-credential-reveal>
<!-- The preview of a compressed picture before it is stored. Builders upload only in the editor. -->
<app-image-confirm *ngIf="!isRuntime"></app-image-confirm>
<mcp-show-highlight-overlay *ngIf="!isRuntime"></mcp-show-highlight-overlay>
<!-- Approval layer: the ONLY place a person approves MCP actions (connect, held, data).
     Rendered only inside the desktop app (the component checks for window.zavoBridge
     and is invisible when no ask is pending). -->
<app-approval-layer *ngIf="isDesktop"></app-approval-layer>
